<template>
  <div class="footer" style="text-align: center">
    <div style="padding-top: 20px;">Maintained by the Bioinformatics Centre, CSIR-CCMB</div>
    <div>Copyright 2020 © GRIDS, CSIR-CCMB, Hyderabad </div>
    <div>Last Updated: {{ lastUpdated }}</div>
  </div>
</template>

<script>
export default {
  name: 'MainFooter',
  props: {
    lastUpdated: String
  }
}
</script>

<style scoped>
.footer {
  margin-top: 100px;
  padding-bottom: 20px;
  /* min-height: 100px; */
  color: white;
  background: #333333;
}
</style>